import { Route, Routes } from 'react-router-dom';
import Theme from './styles/Theme';
import Login from './routes/Login';
import Main from './routes/Main';
import Download from './routes/Download';
import NotFound from './routes/NotFound';
import InternalServerError from './routes/InternalServerError';
// import { GuestRoute, PrivateRoute } from './routes/AuthRouter';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material';

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <div>
          <CssBaseline />
          {/* ルーティングの定義 */}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Main />} />
            <Route path="download" element={<Download />} />
            <Route path='*' element={<NotFound />} />
            <Route path='/notfound' element={<NotFound />} />
            <Route path='/internalServerError' element={<InternalServerError />} />
            {/* TODO: ログイン状態によるリダイレクト処理の共通化 (Mainにユーザー情報を渡せるようにする) */}
            {/* <Route path="/login" element={<GuestRoute>{<Login />}</GuestRoute>} /> */}
            {/* <Route path="/" element={<PrivateRoute>{<Main />}</PrivateRoute>} /> */}
          </Routes>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
